<template>
  <v-dialog
    v-model="dialog"
    width="600"
  >
    <v-card>
      <v-card-title>
        {{ $t('Remove account') }}
      </v-card-title>

      <v-card-text>
        <p v-if="ownedTeamsWithUsers.length > 0">
          {{ $t('Before proceeding with removing your account, you will either have to remove all users from your owned team(s) or assign new team owners using the form below.') }}
        </p>

        <p class="mb-0">
          {{ $t('Please note that this action cannot be undone, your account will be permanently removed.') }}
        </p>
      </v-card-text>

      <v-simple-table v-if="ownedTeamsWithUsers.length > 0">
        <template #default>
          <thead>
            <tr>
              <th
                class="text-left"
                style="width: 50%"
              >
                {{ $t('Name') }}
              </th>
              <th
                class="text-left"
                style="width: 50%"
              >
                {{ $t('New team owner') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="team in ownedTeamsWithUsers"
              :key="team.id"
            >
              <td class="py-3">
                {{ team.name }}
              </td>
              <td class="py-3">
                <v-select
                  v-model="form.new_team_owners[team.id]"
                  :items="team.users"
                  :item-text="user => user.name ? `${user.name} (${user.email})` : user.email"
                  :error-messages="$page.props.errors[`new_team_owners.${team.id}.user_id`]"
                  hide-details
                  item-value="id"
                  :label="$t('Select new team owner')"
                  dense
                  outlined
                />
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text
          @click.native="cancel"
        >
          {{ $t('Cancel') }}
        </v-btn>
        <v-btn
          color="error"
          text
          :disabled="form.processing"
          :loading="form.processing"
          @click="submit"
        >
          {{ $t('Remove my account') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import map from 'lodash/map';

  export default {
    props: {
      errors: {
        type: Object,
        default: () => ({}),
      },
      ownedTeams: {
        type: Array,
        required: true
      }
    },

    data() {
      return {
        dialog: true,
        form: this.$inertia.form({
          new_team_owners: {}
        })
      }
    },

    computed: {
      ownedTeamsWithUsers() {
        return this.ownedTeams.filter(team => {
          return team.users.filter(user => {
            return user.id !== this.$page.props.user.id;
          }).length > 0;
        });
      }
    },

    mounted() {
      this.ownedTeamsWithUsers.forEach(team => {
        this.$set(this.form.new_team_owners, team.id, team.users.length === 0 ? null : team.users[0].id);
      });
    },

    methods: {
      submit() {
        this.form
          .transform(data => {
            const transformed = map(data.new_team_owners, (userId, teamId) => {
              return {
                user_id: parseInt(userId),
                team_id: parseInt(teamId)
              };
            });

            return {
              ...data,
              new_team_owners: transformed
            }
          })
          .post(this.route('remove-account.destroy').toString(), {
            onSuccess: () => this.form.reset()
          });
      },

      cancel() {
        return this.$inertia.visit(this.route('account.index'), {
          preserveState: true
        });
      },

      handleNewTeamOwnerChange(teamId, userId) {
        const value = { team_id: teamId, user_id: userId };

        this.$set(this.form.new_team_owners, teamId, value);
      }
    }
  }
</script>
